import {HttpEvent, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Injectable} from '@angular/core';

@Injectable()
export class MockAuthService {
  logIn(email: string, password: string): Observable<HttpEvent<any>> {
    let response: any;
    switch (email) {
      case 'specialist@mail.com':
        response = {
          'access_token': 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX25hbWUiOiIzMEBtYWlsLmNvbSIsInNjb3B' +
          'lIjpbIm9wZW5pZCJdLCJ1c2VyX3Rva2VuIjoiQ0Y4NjE2QkE2OTJGQ0QwNzg2MUQ2RkU5NDU0MEVCRjIiLCJleHAiOjE1MTAyO' +
          'DYxODYsImF1dGhvcml0aWVzIjpbIlNQRUNJQUxJU1QiXSwianRpIjoiYjBlZDZkYmYtYmZiYy00NDJiLWIyMzctOGViMzA4YWQ3' +
          'MDJlIiwiY2xpZW50X2lkIjoiYWNtZSJ9.ORM7Bfr-jT_IXO5B5WrfQIlp0blb7S1CmR_rwn9LfU3P0qHLxFGbvB3Y505lkIrDWnPi1' +
          'HUu35JX-KR0d24IPYpUaFF76yNMPPiSlELqV7UdDz0D7IKjl5sNgmAXymENGVoexPMN2YePLCCLlxoMe8dw0TQALnn0FdwiAgiRUkL' +
          'qX9E6hRTUf0ceevr1ddw1e-vEgor2-YGg4qj9Hh8Hjuwi4cB1UjMrSgOZ7OmVzUS_Z2BRrm3naNytuzq4lVRsJilDyYlkPahOsutg5' +
          'U6gyIT1r6MNpYo-dmhW5xgpBLR0_9s1Cyoo5Pmhb9PweDVPNS0u3ICaBBaWKTpo8-2Zzg',
          'token_type': 'bearer',
          'refresh_token': 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9' +
          '.eyJ1c2VyX25hbWUiOiI1MDUzQG1haWwuY29tIiwic2NvcGUiOlsib3BlbmlkIl0sImF0aSI6ImQ4ODBmZDVlLWI4YTItNDgxYy04YTc3LWU' +
          '5YTYzYTM5OGZiMyIsInVzZXJfdG9rZW4iOiIxZDAwOGM1YmQxIiwiZXhwIjoxNTEwODM5NDIyLCJhdXRob3JpdGllcyI6WyJTUEVDSUFMSVNUI' +
          'l0sImp0aSI6IjZmNDdkYTQ4LWQ3NWMtNGRiYy04ZDk3LWFjZTgyNzgxOTFkYyIsImNsaWVudF9pZCI6ImFjbWUifQ.Z5XI3EtKMyn9LoYNMVUw' +
          'BsgrYQ8WlBjUUlMO9-au2JvJTZH1ijl54ewTwKI9SwMRtW_hZTfpNAfsOBcRjHYXL0xJB5l7GvbEoeNCep2NC84gWjI3jWGFrMVjdtTgEj3hHB' +
          '6Q7GBvHbgsRjG2qukiMFoQCUNb8ZxDx6mVOgX-00-2bc2vs0Z4d1DrpDOYQYVOMQH6-QSHPMyjEzh0Yt8auw0Ss2taIe4YsiSgL5JvQ7OCfhxWe' +
          'ctiEwCUkaVyCf5U2LIwFolXmpnn0qbhQ-tbyueP_USj0gkY_to5e5sPD2Yx-nPF3T95tOBf4aOfUgApk4Qt_0hiXsYmtDDEHmKS5w',
          'expires_in': 43199,
          'scope': 'openid',
          'user_token': '1d008c5bd1',
          'jti': 'd880fd5e-b8a2-481c-8a77-e9a63a398fb3'
        };
        break;
      case 'practitioner@mail.com':
        response = {
          'access_token': 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX25hbWUiOiI3Mjc0OUBtYWlsLmNvbSIsInNjb3BlI' +
          'jpbIm9wZW5pZCJdLCJ1c2VyX3Rva2VuIjoiOTgxRDRDRjIyOUQ4MzBGMjcxOEU2RkUzOTlFNTNDNUQiLCJleHAiOjE1MTAyNjc3MDA' +
          'sImF1dGhvcml0aWVzIjpbIlBSQUNUSVRJT05FUiJdLCJqdGkiOiI3Y2U4Zjc1Ny1iNTYyLTQxODUtYmE4MC03NTY4ZDEzY2FiMmMiL' +
          'CJjbGllbnRfaWQiOiJhY21lIn0.gV5jbZGJA6MJZwjONS7EGFx-5HZ0EZVutbSGrQxrE4ZOmrJ58GcKBObD_95zKd-DL3jkEh3BHjs' +
          '6OWXpNuUbkN4vTVlmhI_WmksG8iqU2EQY5zS49OsQzPiS_crT0LRHUhVB6bLX2gpKu3TGq1l0grMk77OhJHcvf2QPGt4Z8ApjtenM2' +
          'onUH5a5R304GnQAdjdEiRpbhwt8I7OXKLFN8JVY_weAmLtrag2F0HGjmntLC53-gGTZVH2DiqrjoyhWBXficknm8b4cxgnJQRB98si' +
          'DIOEYghJ5hqRnEb_1FGYOmT6RSYIpSY4EB_xmNicTLH753BdXQ3xBx6yXLMB6kg',
          'token_type': 'bearer',
          'refresh_token': 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX25hbWUiOiI3Mjc0OUBtYWlsLmNvbSIsInNjb3Bl' +
          'IjpbIm9wZW5pZCJdLCJhdGkiOiI3Y2U4Zjc1Ny1iNTYyLTQxODUtYmE4MC03NTY4ZDEzY2FiMmMiLCJ1c2VyX3Rva2VuIjoiOTgxRDR' +
          'DRjIyOUQ4MzBGMjcxOEU2RkUzOTlFNTNDNUQiLCJleHAiOjE1MTI2Mzg3NDEsImF1dGhvcml0aWVzIjpbIlBSQUNUSVRJT05FUiJdL' +
          'CJqdGkiOiJhNTEzYTQyNy0xY2I4LTRiNmUtYmI5NC01ODczZDI1MWQwOWUiLCJjbGllbnRfaWQiOiJhY21lIn0.O9JpZVnwauseFGq' +
          'PTqk9bpKPFOmXLkEjtYllFxkimhHShlZJHh-YjUvdOEKokfeuYIIwarBvXJILiwyTC6yb2QEvZj_TBVYJvAsUeluhoDciYSGoXmV6Tgq' +
          'ei6hyYi896SXhYc91gtJkjIIPUCWQzL6nMDAdGSt_rlPKLOPN59-hLdQ5QIx5-7MXgpDfwDbc6P_2j6Bsq87fxNdgqYxgPUhNudu1x' +
          'APC-exMrik3t9e44fYUm9lEsmMNWRVamty4-Qok8fwpdpTL0VYtlAeGflAYseFHWlqhurZuVH2A-NwMc_VOmrgSA0IAi_dYIy-vAWSX' +
          'K1hKV4P_N7TRLQ4C5A',
          'expires_in': 43199,
          'scope': 'openid',
          'user_token': '981D4CF229D830F2718E6FE399E53C5D',
          'jti': '7ce8f757-b562-4185-ba80-7568d13cab2c'
        };
        break;
      default:
        response = {
          'access_token': 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX25hbWUiOiI3Mjc0OUBtYWlsLmNvbSIsInNjb3BlI' +
          'jpbIm9wZW5pZCJdLCJ1c2VyX3Rva2VuIjoiOTgxRDRDRjIyOUQ4MzBGMjcxOEU2RkUzOTlFNTNDNUQiLCJleHAiOjE1MTAyNjc3MDA' +
          'sImF1dGhvcml0aWVzIjpbIlBSQUNUSVRJT05FUiJdLCJqdGkiOiI3Y2U4Zjc1Ny1iNTYyLTQxODUtYmE4MC03NTY4ZDEzY2FiMmMiL' +
          'CJjbGllbnRfaWQiOiJhY21lIn0.gV5jbZGJA6MJZwjONS7EGFx-5HZ0EZVutbSGrQxrE4ZOmrJ58GcKBObD_95zKd-DL3jkEh3BHjs' +
          '6OWXpNuUbkN4vTVlmhI_WmksG8iqU2EQY5zS49OsQzPiS_crT0LRHUhVB6bLX2gpKu3TGq1l0grMk77OhJHcvf2QPGt4Z8ApjtenM2' +
          'onUH5a5R304GnQAdjdEiRpbhwt8I7OXKLFN8JVY_weAmLtrag2F0HGjmntLC53-gGTZVH2DiqrjoyhWBXficknm8b4cxgnJQRB98si' +
          'DIOEYghJ5hqRnEb_1FGYOmT6RSYIpSY4EB_xmNicTLH753BdXQ3xBx6yXLMB6kg',
          'token_type': 'bearer',
          'refresh_token': 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX25hbWUiOiI3Mjc0OUBtYWlsLmNvbSIsInNjb3Bl' +
          'IjpbIm9wZW5pZCJdLCJhdGkiOiI3Y2U4Zjc1Ny1iNTYyLTQxODUtYmE4MC03NTY4ZDEzY2FiMmMiLCJ1c2VyX3Rva2VuIjoiOTgxRDR' +
          'DRjIyOUQ4MzBGMjcxOEU2RkUzOTlFNTNDNUQiLCJleHAiOjE1MTI2Mzg3NDEsImF1dGhvcml0aWVzIjpbIlBSQUNUSVRJT05FUiJdL' +
          'CJqdGkiOiJhNTEzYTQyNy0xY2I4LTRiNmUtYmI5NC01ODczZDI1MWQwOWUiLCJjbGllbnRfaWQiOiJhY21lIn0.O9JpZVnwauseFGq' +
          'PTqk9bpKPFOmXLkEjtYllFxkimhHShlZJHh-YjUvdOEKokfeuYIIwarBvXJILiwyTC6yb2QEvZj_TBVYJvAsUeluhoDciYSGoXmV6Tgq' +
          'ei6hyYi896SXhYc91gtJkjIIPUCWQzL6nMDAdGSt_rlPKLOPN59-hLdQ5QIx5-7MXgpDfwDbc6P_2j6Bsq87fxNdgqYxgPUhNudu1x' +
          'APC-exMrik3t9e44fYUm9lEsmMNWRVamty4-Qok8fwpdpTL0VYtlAeGflAYseFHWlqhurZuVH2A-NwMc_VOmrgSA0IAi_dYIy-vAWSX' +
          'K1hKV4P_N7TRLQ4C5A',
          'expires_in': 43199,
          'scope': 'openid',
          'user_token': '981D4CF229D830F2718E6FE399E53C5D',
          'jti': '7ce8f757-b562-4185-ba80-7568d13cab2c'
        };
    }
    return new Observable(resp => {
      resp.next(new HttpResponse({
        status: 200,
        body: response
      }));
      resp.complete();
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/mock/mock-auth.service.ts